import 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { emptyButtonStyle } from '../EmptyButton';
import { AdditionalTeachersForm } from './AdditionalTeachersForm';
import { Teacher } from '@teetsh/app/src/containers/Livrets/types/livret';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onUpdate: (v: Teacher) => Promise<any>;
}

export function AddAdditionalTeachers(props: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation(['carnet']);
  if (!isOpen) {
    return (
      <Button
        onClick={() => setIsOpen(true)}
        minimal
        small
        css={emptyButtonStyle}
      >
        {t('carnet:actions.addTeacher')}
      </Button>
    );
  }
  return <AdditionalTeachersForm {...props} onClose={() => setIsOpen(false)} />;
}
